export const USER_STATUS_VARIANTS = {
  pending: 'PENDING',
  active: 'ACTIVE',
  archived: 'ARCHIVED',
  inactive: 'INACTIVE',
  rejected: 'REJECTED',
};

export const USER_STATUS_OPTIONS = [
  USER_STATUS_VARIANTS.pending,
  USER_STATUS_VARIANTS.active,
  USER_STATUS_VARIANTS.archived,
  USER_STATUS_VARIANTS.inactive,
  USER_STATUS_VARIANTS.rejected,
];
